//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SmartImage from '~/components/SmartImage';
import WorklogSection from '~/components/WorklogSection.vue';
import Invoice from '~/components/Invoice.vue';
import ImageDialog from '~/components/ImageDialog.vue';

export default {
  name: 'TaskInformation',
  components: { SmartImage, Section: WorklogSection, Invoice },
  props: {
    order: {
      type: Object,
      required: true,
    },
    skill: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openImage(image) {
      this.$root.$emit('push-dialog', {
        component: ImageDialog,
        title: this.$t('order.completion.image'),
        params: {
          image,
        },
      });
    },
  },
};
